var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95475 9.26189H5.47271C5.79794 9.26189 6.06319 9.56351 6.06319 9.93335V14.4841C6.06319 14.854 5.79794 15.1556 5.47271 15.1556H3.95475C3.62951 15.1556 3.36427 14.854 3.36427 14.4841V9.93335C3.36427 9.56356 3.62951 9.26189 3.95475 9.26189ZM17.8506 17.2655H1.50879V1.11204C1.50879 0.824702 1.30394 0.591797 1.05125 0.591797C0.798567 0.591797 0.59375 0.824702 0.59375 1.11204V17.7858C0.59375 18.0731 0.798567 18.3061 1.05125 18.3061H17.8505C18.1032 18.3061 18.308 18.0731 18.308 17.7858C18.3081 17.4985 18.1032 17.2655 17.8506 17.2655ZM9.10871 5.6295H10.6267C10.9519 5.6295 11.2171 5.93112 11.2171 6.30096V14.4842C11.2171 14.854 10.9519 15.1556 10.6267 15.1556H9.10871C8.78348 15.1556 8.51823 14.854 8.51823 14.4842V6.30096C8.51823 5.93112 8.78348 5.6295 9.10871 5.6295ZM14.2627 2.20065H15.7806C16.1059 2.20065 16.3711 2.50227 16.3711 2.8721V14.4842C16.3711 14.854 16.1059 15.1556 15.7806 15.1556H14.2627C13.9374 15.1556 13.6722 14.854 13.6722 14.4842V2.8721C13.6722 2.50227 13.9374 2.20065 14.2627 2.20065Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToBarChart);
export default __webpack_public_path__ + "static/media/to-bar-chart.9cb7827469ceea823e4a0d52cc8c04a2.svg";
export { ForwardRef as ReactComponent };